import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import config from "../config";
import {PhaseRecordFormProps} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<PhaseRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >

            <RecordForm
                record={record}
                handleSubmit={(values) => {
                    handleSubmit(values)
                    onClose();
                }}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
